module.exports = __webpack_public_path__ + "static/media/IMG_9165.4df9ef9d.jpg";